import React, { useState, useEffect, useContext } from "react";
import {
  Col,
  Container,
  Row,
  Accordion,
  Image,
  Form,
  InputGroup,
  Button,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./NewCheckOut.css";
import { connect } from "react-redux";
import { fetchSingleDeliveryAddressStart } from "../store/actions/DeliveryAction";
import { fetchCartListStart } from "../store/actions/CartsAction";
import SomethingWrong from "../Helper/SomethingWrong";
import Skeleton from "react-loading-skeleton";
import { fetchUserWalletDetailsStart } from "../store/actions/WalletAction";
import { withTranslation, useTranslation } from "react-multi-lang";
import { saveOrdersCartStart, ordersCheckoutStart } from "../store/actions/OrdersAction";
import AddMoneyModal from "./AddMoneyModal";
import {
  useAccount,
} from "wagmi";
import { ConnectKitButton } from "connectkit";
import CheckoutWalletButton from "./CheckoutWalletButton";

const CheckoutPayment = (props) => {
  const account = useAccount();
  const navigate = useNavigate();
  const t = useTranslation();

  const [skipRender, setSkipRender] = useState(true);
  const [showContent, setShowContent] = useState(true);
  const [checkout, setCheckout] = useState(true);
  const [addMoney, setAddMoney] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("addessUniqueId")) {
      props.dispatch(fetchSingleDeliveryAddressStart({
        delivery_address_unique_id: localStorage.getItem("addessUniqueId")
      }));
      props.dispatch(fetchCartListStart());
      props.dispatch(fetchUserWalletDetailsStart());
    } else {
      navigate("/checkout-address");
    }
  }, []);

  useEffect(() => {
    if (!skipRender && !props.cartList.loading && Object.keys(props.cartList.data).length > 0 && props.userWalletDetails.data.user_wallet &&
      !props.userWalletDetails.loading && Object.keys(props.userWalletDetails.data).length > 0 && props.cartList.data.user_cart_amount) {
      if (props.userWalletDetails.data.user_wallet.remaining >= props.cartList.data.user_cart_amount.cart_final_amount) {
        setCheckout(true);
      } else {
        setCheckout(false);
      }
    }
  }, [props.userWalletDetails, props.cartList]);

  useEffect(() => {
    if (!skipRender &&
      (!props.singleDeliveryAddress.loading && (props.singleDeliveryAddress.error !== false || !props.singleDeliveryAddress.data.delivery_address)) ||
      (!props.cartList.loading && (props.cartList.error !== false || !props.cartList.data.carts || !props.cartList.data.user_cart_amount ||
        !props.cartList.data.availability || !props.cartList.data.availability.is_available)) ||
      (!props.userWalletDetails.loading && (props.userWalletDetails.error !== false || !props.userWalletDetails.data.user_wallet))) {
      setShowContent(false);
    }
  }, [props.singleDeliveryAddress, props.cartList, props.userWalletDetails]);

  useEffect(() => {
    if (!skipRender && !props.orderSaveCart.loading && Object.keys(props.orderSaveCart.data).length > 0) {
      localStorage.removeItem("addessUniqueId");
      navigate("/order-placed");
    }
    setSkipRender(false);
  }, [props.orderSaveCart]);

  const changeAddress = e => {
    e.preventDefault();
    localStorage.removeItem("addessUniqueId");
    navigate("/checkout-address");
  }

  const checkoutCart = e => {
    e.preventDefault();
    props.dispatch(saveOrdersCartStart({
      delivery_address_id: props.singleDeliveryAddress.data.delivery_address.delivery_address_id,
      payment_mode: "WALLET",
    }));
  }

  const closeAddMoneyModal = () => {
    setAddMoney(false);
  }

  // const onCheckout = e => {
  //   e.preventDefault();
  //   const amount = "10";
  //   const stableTokenAmount = amount.toString();
  //   const web3 = window.web3;
  //   let stable_token_amount = window.web3.utils.toWei(stableTokenAmount, "Ether");
  //   // let stable_token_amount = web3.utils.toWei(stableTokenAmount);

  //   let USDVToken = new web3.eth.Contract(
  //     Token.abi,
  //     "0xcD7509b76281223f5B7d3aD5d47F8D7Aa5C2B9bf"
  //   );
  //   USDVToken.methods
  //     .approve(
  //       // configuration.get("configData.seller_contract_address"),
  //       "0xcBD25127B97D1F170b5efFa36A7894FCbf43314D",
  //       stable_token_amount
  //     )
  //     .send({ from: walletAccount.address })
  //     .on("receipt", (receipt) => {
  //       console.log(receipt);
  //     })
  //     .on("error", (error) => {
  //       // setButtonContent("");
  //       console.log("Error", error);
  //       if (error.message == undefined) {
  //         props.dispatch(getErrorNotificationMessage("Unexpected error occuried, Please try again..."));
  //       } else {
  //         props.dispatch(getErrorNotificationMessage(error.message));
  //       }
  //       // Send error notification.
  //     });
  // }

  const onFormSubmit = (paymentMode, data = {}) => {
    props.dispatch(ordersCheckoutStart({
      payment_mode: paymentMode,
      delivery_address_id: props.singleDeliveryAddress.data.delivery_address.delivery_address_id,
      ...data,
    }));
  }

  useEffect(() => {
    if (!skipRender && !props.ordersCheckout.loading && Object.keys(props.ordersCheckout.data).length > 0) {
      localStorage.removeItem("addessUniqueId");
      navigate("/order-placed");
    }
    setSkipRender(false);
  }, [props.ordersCheckout]);

  return (
    <>
      <div className="newcheckout-sec">
        {showContent
          ? <Container>
            <Row>
              <Col xl={8} md={12} className="resp-mrg-btm-md">
                <div className="newcheckout-header-sec">
                  <ul className="list-unstyled new-checkout-progress-bar">
                    <li className="step1">
                      <div className="newcheckout-flex active">
                        <div className="count-no">
                          1
                        </div>
                        <h6>{t("address")}</h6>
                      </div>
                    </li>
                    <li className="step2">
                      <div className="newcheckout-flex active">
                        <div className="count-no">
                          2
                        </div>
                        <h6>{t("order_summary")}</h6>
                      </div>
                    </li>
                    <li className="step3">
                      <div className="newcheckout-flex active">
                        <div className="count-no">
                          3
                        </div>
                        <h6>{t("payment")}</h6>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="newcheckout-body-wrapper">

                  <div className="step-3">
                    <div className="product-delivery-address-box">
                      {props.singleDeliveryAddress.loading
                        ? <Skeleton height={200} />
                        : props.singleDeliveryAddress.data.delivery_address
                          ? <div className="saved-address-box">
                            <div className="address-details">
                              <h3>{t("deliver_to")}</h3>
                              <h4>{props.singleDeliveryAddress.data.delivery_address.name}</h4>
                              <p className="address-block">
                                {props.singleDeliveryAddress.data.delivery_address.address}{"\n"}
                                {props.singleDeliveryAddress.data.delivery_address.city}{" "}
                                {props.singleDeliveryAddress.data.delivery_address.state}{" "}
                                {props.singleDeliveryAddress.data.delivery_address.pincode}{"\n"}
                                {props.singleDeliveryAddress.data.delivery_address.landmark}{"\n"}
                                {props.singleDeliveryAddress.data.delivery_address.contact_number}
                              </p>
                            </div>
                            <div className="address-btn">
                              <Button
                                className="address-button"
                                onClick={changeAddress}
                              >
                                {t("change")}
                              </Button>
                            </div>
                          </div>
                          : null
                      }
                    </div>
                    <div className="product-order-summary-card">
                      <h3>{t("order_summary")} - <span>{
                        props.cartList.loading
                          ? "..."
                          : props.cartList.data.carts ?
                            props.cartList.data.carts.filter(cart => cart.product.stock_status === 1).length
                            : ""
                      } {t("products")}</span></h3>
                      <div className="address-btn">
                        <Link to="/cart" className="address-button">
                          {t("change")}
                        </Link>
                      </div>
                    </div>
                    <div className="payment-radio-box">
                      {/* <div className="payment-radio-btn">
                      <input
                        name="plan"
                        className="radio"
                        type="radio"
                        checked
                        id="payment"
                      />
                      <label
                        name="plan"
                        className="radio"
                        type="radio"
                        checked
                        for="payment"
                      >
                        <p>
                          <Image
                            src={
                              window.location.origin + "/images/visa.png"
                            }
                            type="image/png"
                          />
                        </p>
                        <p>41xx xxxx xxxx 5609</p>
                        <p>John Mathew</p>
                        <p>10/2022</p>
                        <Link to="" className="card-edit-icon">
                          <span>
                            <Image
                              src={
                                window.location.origin +
                                "/images/delete-1.svg"
                              }
                              type="image/png"
                            />
                          </span>
                          Delete
                        </Link>
                        <div></div>
                      </label>
                    </div>

                    <div className="payment-radio-btn label-bg">
                      <input
                        name="plan"
                        className="radio"
                        type="radio"
                        checked
                        id="payment-1"
                      />
                      <label
                        name="plan"
                        className="radio"
                        type="radio"
                        checked
                        for="payment-1"
                      >
                        <p>
                          <Image
                            src={
                              window.location.origin + "/images/express.png"
                            }
                            type="image/png"
                          />
                        </p>
                        <p>41xx xxxx xxxx 5609</p>
                        <p>John Mathew</p>
                        <p>10/2022</p>
                        <Link to="" className="card-edit-icon">
                          <span>
                            <Image
                              src={
                                window.location.origin +
                                "/images/delete-1.svg"
                              }
                              type="image/png"
                            />
                          </span>
                          Delete
                        </Link>
                        <div></div>
                      </label>
                    </div> */}
                      {props.userWalletDetails.loading ?
                        <Skeleton height={100} />
                        : checkout
                          ? <div className="payment-radio-btn label-bg dropdown-wallet">
                            <input
                              name="plan"
                              className="radio"
                              type="radio"
                              checked
                              id="payment-2"
                            />
                            <label
                              name="plan"
                              className="radio"
                              type="radio"
                              checked
                              for="payment-2"
                            >
                              <p>
                                <Image
                                  src={
                                    window.location.origin + "/images/wallet.svg"
                                  }
                                  type="image/png"
                                />
                                <span>{t("wallet")}</span>
                              </p>
                              <p>{props.userWalletDetails.data.user_wallet.remaining_formatted}</p>
                            </label>
                          </div>
                          : <div className="payment-radio-btn label-bg dropdown-wallet mt-3">
                            <label
                              name="plan"
                              className="payment-add-money-wallet"
                            >
                              <p>
                                <Image
                                  src={
                                    window.location.origin + "/images/wallet.svg"
                                  }
                                  type="image/png"
                                />
                                <span>{t("wallet")}</span>
                              </p>
                              <p>{props.userWalletDetails.data.user_wallet.remaining_formatted}</p>
                              <Button
                                className="address-button"
                                onClick={() => setAddMoney(true)}
                              >
                                {t("add_money")}
                              </Button>
                            </label>
                          </div>
                      }
                      {props.cartList.loading ?
                        ""
                        : props.cartList.data.user_cart_amount &&
                          props.cartList.data.availability &&
                          props.cartList.data.availability.is_available
                          ? <>
                            {/* {account.address ?
                              !props.singleDeliveryAddress.loading ?
                                <CheckoutWalletButton
                                  cartFinalAmount={props.cartList.data.user_cart_amount.cart_final_amount}
                                  onFormSubmit={onFormSubmit}
                                />
                                : null
                              :
                              <>
                                <div className="payment-radio-btn label-bg dropdown-wallet mt-3">
                                  <label
                                    name="plan"
                                    className="payment-add-money-wallet"
                                  >
                                    <p>
                                      <Image
                                        src={
                                          window.location.origin + "/images/wallet.svg"
                                        }
                                        type="image/png"
                                      />
                                      <span>Wallet</span>
                                    </p>
                                    <p>Not Connected</p>
                                    <ConnectKitButton.Custom>
                                      {({ isConnected, isConnecting, show, hide, address, ensName }) => {
                                        return (
                                          <Button
                                            className="address-button"
                                            onClick={() => show()}
                                          >
                                            Connect
                                          </Button>
                                        );
                                      }}
                                    </ConnectKitButton.Custom>
                                  </label>
                                </div>
                              </>
                            } */}
                            {/* Direct Payment Btn */}
                            {/* <div className="payment-radio-btn label-bg dropdown-wallet mt-3">
                              <label
                                name="plan"
                                className="payment-add-money-wallet"
                              >
                                <p>
                                  <Image
                                      src={
                                        window.location.origin + "/images/wallet.svg"
                                      }
                                      type="image/png"
                                    />
                                  <span>Checkout</span>
                                </p>
                                <p>Not Connected</p>
                                <Button
                                  className="address-button"
                                  onClick={() => onFormSubmit("ADMIN")}
                                  disabled={props.ordersCheckout.buttonDisable}
                                >
                                  {props.ordersCheckout.loadingButtonContent ? props.ordersCheckout.loadingButtonContent : "Pay"}
                                </Button>
                              </label>
                            </div> */}
                          </>
                          : null
                      }
                    </div>
                    {/* <Link to="#" className="add-new-address-link">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" /></svg>
                    ADD CARD
                  </Link> */}
                    <div className="product-confirm-continue-box">
                      <h4>Confirm And Pay</h4>
                      <div className="address-btn">
                        <Button
                          disabled={!checkout || props.orderSaveCart.buttonDisable}
                          className="address-button"
                          onClick={checkoutCart}
                        >
                          {props.orderSaveCart.loadingButtonContent ?
                            props.orderSaveCart.loadingButtonContent
                            : t("continue")
                          }
                        </Button>
                      </div>
                    </div>
                  </div>

                </div>
              </Col>
              <Col xl={4} md={12}>
                <div className="checkout-box">
                  <div className="cart-box">
                    <div className="cart-header-sec">
                      <h4>{t("price_details")}</h4>
                    </div>
                    {props.cartList.loading
                      ? <Skeleton height={200} />
                      : <div className="cart-body-sec">
                        <div className="cart-summary-info">
                          <div className="cart-summary-header">
                            <p>
                              {t("cart_total")} <span>{props.cartList.data.user_cart_amount.cart_total_amount}</span>
                            </p>
                            <p>
                              {t("discount")} <span>-{props.cartList.data.user_cart_amount.cart_discount_amount}</span>
                            </p>
                          </div>
                          <div className="cart-summary-total-amount">
                            <h5>
                              {t("order_total")} <span>{props.cartList.data.user_cart_amount.cart_checkout_amount}</span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          : <div className="text-center">
            <SomethingWrong />
            <Button onClick={() => navigate("/")}>{t("go_home")}</Button>
          </div>
        }
      </div>
      {addMoney ?
        <AddMoneyModal
          addMoney={addMoney}
          closeAddMoneyModal={closeAddMoneyModal}
        />
        : null
      }
    </>
  );
};

const mapStateToPros = (state) => ({
  cartList: state.carts.cartList,
  singleDeliveryAddress: state.delivery.singleDeliveryAddress,
  userWalletDetails: state.wallet.userWalletDetails,
  orderSaveCart: state.orders.orderSaveCart,
  ordersCheckout: state.orders.ordersCheckout,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(withTranslation(CheckoutPayment));
